// extracted by mini-css-extract-plugin
export default {"recommendations":"SupplyList_recommendations__0irQH","recommendationItem":"SupplyList_recommendationItem__cAGwE"};